import React, { Component } from 'react';
import _ from 'lodash';
import { Table, Pagination, } from 'react-bootstrap';


export default class ReportSummaryView extends Component {
  constructor(props){
    super(props)
    this.state= {
      activePage: 1,
      // orderBy:"asc",
      // showFilter:false,
      filterRows: {}
    }
   }
   UNSAFE_componentWillMount(){
    this.setState({reportData:this.props.reportData})
   }
   UNSAFE_componentWillReceiveProps(nextProps){
    if(!_.isEqual(this.props.reportData, nextProps.reportData)){
      this.setState({reportData:nextProps.reportData})
    }

  }

  handleSelectPagination = (eventKey) => {
    this.setState({
      activePage: eventKey,
    });
	}
	handleSelectPaginationPrev = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage-1,
    });
	}
	handleSelectPaginationNext = () => {
		const {activePage} = this.state;
		this.setState({
      activePage: activePage+1,
    });
  }
  // handleSort = (column) => {
  //   const {orderBy, reportData} = this.state
  //   var data = _.orderBy(reportData.value, column, orderBy);
  //   reportData.value = data
  //   this.setState({reportData})
  //   if(orderBy === "asc"){
  //    this.setState({orderBy:"desc"})
  //   } else {
  //    this.setState({orderBy:"asc"})
  //   }
  // }
  
  // handleFilter = () =>{
  //   this.setState((prevState) =>{
  //     return {showFilter: !prevState.showFilter};
  //   })
  //   if(!_.isNull(this.state.filterRows)){
  //     let keys = _.keys(this.state.filterRows)
  //     _.map(keys, (obj) =>{
  //       this.setState({[obj]:""})
  //     })
  //     this.setState({filterRows:{}})
  //   }
  // }
  mapDatabodyData = (data, startOffset, startCount, Per_Page, fields) =>{
    let returnObj=[];
    _.map(data, (xx, index)=> {
      if(index >= startOffset & startCount < Per_Page){
        startCount++;  
        if(_.has(xx, "subValues")){          
        returnObj.push(                
            _.map(xx.subValues, (obj, i) => {
            return(<tr>
            {
            _.map(fields, (dd) =>{      
              let returnObj1 =[]         
              let retvalue1 = _.get(xx, dd.value) 
              let retvalue = _.get(obj, dd.value)  
              if(typeof retvalue1 !== "undefined" && i===0){
                returnObj1.push(<th rowSpan={xx.subValues.length}>{retvalue1}</th>)
              } 
              if(typeof retvalue !== "undefined"){
                returnObj1.push(<td>{retvalue}</td>)
              }
                return returnObj1
            })            
            } 
            </tr>)            
            })
       );
        }
      }
  })
   return returnObj 
  }

  handleChange = (e) => {
    const {filterRows} = this.state
    let filterCol = filterRows
    if(_.has(filterCol, e.target.id)){
      filterCol[e.target.id]  = e.target.value
    } else {
      filterCol = Object.assign(filterCol, {[e.target.id]:e.target.value})
    }
    this.setState({[e.target.id]:e.target.value, filterRows:filterCol})	
  }
 
 
  render(){
    const{activePage, reportData} = this.state; 
    const Per_Page=20;
		let totalPages = 1
		const startOffset = (this.state.activePage-1) * Per_Page;
		let startCount = 0;
    let items = [];
    
    if(!_.isEmpty(reportData) && !_.isEmpty(reportData.value)){
      totalPages = Math.ceil(reportData.value.List.length/Per_Page)
		for (let number = 1; number <= totalPages; number++) {
			items.push(
				<Pagination.Item key={number} active={number === activePage} onClick={()=>this.handleSelectPagination(number)}>
					{number}
				</Pagination.Item>				
			);
      }
    }
  
    let fields=[];
    let length=1;
    let headerLength = 1;    
    //let filterfield=[]
    return(
    <div className="reportDataView" >
      {(!_.isEmpty(reportData.value) && !_.isEmpty(reportData.value.List)) ?
      <div>
        <Table responsive bordered>
        <thead>
        <tr>
          {
            _.map(reportData.header, (obj, index) => {
              headerLength = reportData.header.length
              let index1;
              _.map(reportData.value, (val) => { index1 = _.findIndex(val.filledValues, {"label": obj.label})})
              // let newCol = "filledValues["+index1+"]"+".value"
              // if(index1 >= 0){
              //   obj.value = newCol
              // }
              fields.push(obj)
              // filterfield.push(<td><FormControl
              //                       placeholder="Search"
              //                       aria-label="Search"
              //                       aria-describedby="basic-addon1"
              //                       id={obj.value}
              //                       onChange={(e) => this.handleChange(e)}
              //                       value={this.state[obj.value]}
              //                       /></td>)  
              return <th colSpan={length}>              
              {obj.label.toUpperCase()}&nbsp;</th>;
            })}
          </tr>
        </thead>
        <tbody>
        { (!_.isEmpty(reportData.value) && !_.isEmpty(reportData.value.List))?
        this.mapDatabodyData(reportData.value.List,  startOffset, startCount, Per_Page, fields)   
        :  <tr><td colSpan={headerLength}>No Record Found</td></tr>
         }    
          {(_.has(reportData, "grandTotal") && !_.isNull(reportData.grandTotal))  ?
          <tr>
          {_.map(fields, (obj)=> {
            return( <th>{_.get(reportData.grandTotal, obj.value)}</th>  )
            }) 
          }
          </tr>  : null } 
        </tbody>
      </Table>
      <br/>
      <Pagination>
				<Pagination.First  disabled={activePage === 1} onClick={()=>this.handleSelectPagination(1)} />
				<Pagination.Prev   disabled={activePage === 1} onClick={this.handleSelectPaginationPrev} />
          {items[activePage-1]}
          {items[activePage] ? items[activePage] : (activePage !== 1) ? items[0] : null}
          {items[activePage+1]}
				<Pagination.Next disabled={activePage === totalPages} onClick={this.handleSelectPaginationNext}/>
				<Pagination.Last disabled={activePage === totalPages} onClick={()=>this.handleSelectPagination(totalPages)}/>			
				</Pagination>
      </div>:
     <Table responsive bordered className='marginTop'><tbody><tr><td>No Records Found</td></tr></tbody></Table>}
    </div>)
  }
}